export default "__VITE_ASSET__925588aa__"